export default "__VITE_ASSET__QB6yy1gp__"